<template>
  <div class="frame">
    <keep-alive>
      <router-view/>
    </keep-alive>
    <van-tabbar class="tabbar" v-model="active" active-color="#e9aea8">
      <van-tabbar-item
        :to="item.path"
        v-for="(item,index) in list"
        :key="index"
        @click="keepActive(index)"
      >
        <img
          class="tabberImg"
          slot="icon"
          slot-scope="props"
          :src="props.active ? item.activeIcon : item.icon"
        >
        <span>{{item.name}}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";

export default {
  components: {
    [TabbarItem.name]: TabbarItem,
    [Tabbar.name]: Tabbar
  },

  data() {
    return {
      active: 0,
      list: [
        {
          name: "首页",
          icon: require("../assets/frame-img/home1.png"),
          activeIcon: require("../assets/frame-img/home.png"),
          path: "/"
        },
        {
          name: "分类",
          icon: require("../assets/frame-img/fenlei1.png"),
          activeIcon: require("../assets/frame-img/fenlei.png"),
          path: "/pages/category/index"
        },
        {
          name: "社区",
          icon: require("../assets/frame-img/shequ1.png"),
          activeIcon: require("../assets/frame-img/shequ.png"),
          path: "/community"
        },
        {
          name: "购物车",
          icon: require("../assets/frame-img/gouwuche1.png"),
          activeIcon: require("../assets/frame-img/gouwuche.png"),
          path: "/pages/flow/index"
        },
        {
          name: "我的",
          icon: require("../assets/frame-img/wode1.png"),
          activeIcon: require("../assets/frame-img/wode.png"),
          path: "/pages/user/index"
        }
      ]
    };
  },
  created() {
    if (sessionStorage.getItem("tabbarActive") != null) {
      this.active = parseInt(sessionStorage.getItem("tabbarActive"));
    }
  },
  mounted() {
  },
  activated() {
    let arr = ['/home', '/pages/category/index', '/community', '/pages/flow/index', '/pages/user/index'];
    if(arr.indexOf(this.$route.path)>-1) {
      this.active = arr.indexOf(this.$route.path)
    }
  },
  methods: {
    keepActive(index) {
      sessionStorage.setItem("tabbarActive", index);
    }
  }
};
</script>

<style lang="less" scoped>
.frame {
  padding-bottom: 50px;
}
.tabberImg {
  width: 20px;
  height: 20px;
  margin-bottom: 2px;
}
</style>
<style>
.van-tabbar-item .van-tabbar-item__text {
  margin-top: -5px;
}
</style>
